export default function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/order/none.js
// module id = null
// module chunks = 